import { LoadingButton } from '@mui/lab'
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAuthContext } from 'src/auth/useAuthContext'
import CustomModal from 'src/components/customerinput/CustomModal'
import { notify } from 'src/components/notify'
import createRequestStatus from 'src/services/campian/createRequestStatus'

export default function StatusModal({ open, close, setReload, editData }) {
    const { user } = useAuthContext()
    const [type, setType] = useState('')
    const [reason, setReason] = useState('')

    const handleSubmit = async () => {
        if (["rejected"].includes(type)) {
            if (!reason.trim()) {
                return notify("Please enter reason.")
            }
        }
        let data;
        data = await createRequestStatus(user, { phone_number_id: editData?._id, status: type, reason: reason })
        if (data) {
            setReload((prev) => !prev)
            notify('Update Successfully.', "success")
            close()
        }
    }
    useEffect(() => {
        if (editData) {
            setType(editData?.status?.toLowerCase())
            setReason(editData?.reason || "")
        }
    }, [open])
    return (
        <div>
            <CustomModal open={open} close={close} heading="Meta Status" action={<LoadingButton variant="contained" onClick={handleSubmit}>Confirm</LoadingButton>}>
                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">Status</FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        row
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    >
                        <FormControlLabel value="approved" control={<Radio />} label="Approved" />
                        <FormControlLabel value="on_hold" control={<Radio />} label="On Hold" />
                        <FormControlLabel value="in_progress" control={<Radio />} label="In Progress" />
                        <FormControlLabel value="rejected" control={<Radio />} label="Rejected" />
                    </RadioGroup>
                </FormControl>
                {["rejected"].includes(type) && <>
                    <Typography>Reason</Typography>
                    <TextField fullWidth placeholder='Enter reason' size="small"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}

                    />
                </>}

            </CustomModal>
        </div>
    )
}
